export default __webpack_public_path__ + "static/media/25_2_0.68a7ca03.png";